import { io } from 'socket.io-client'

const { VITE_APP_SERVER } = import.meta.env
let sockets = {
    sublet: [],
    subletAgent: [],
}

function ioInit(options = {}) {
    return new Promise(resolve => {
        const { auth, namespace = '/sublet' } = options
        const socketIndex = auth?.token ? 1 : 0
        const namespaceKey = namespace.replace('/', '')

        if (sockets[namespaceKey][socketIndex]) {
            resolve(sockets[namespaceKey][socketIndex])
            return
        }

        sockets[namespaceKey][socketIndex] = io(VITE_APP_SERVER + namespace, {
            transports: ['websocket'],
            auth,
        })

        sockets[namespaceKey][socketIndex].on('connect', () => {
            console.info(`connected to ${sockets[namespaceKey][socketIndex].nsp} namespace`)
        }).on('disconnect', reason => {
            console.info(`disconnected from ${sockets[namespaceKey][socketIndex].nsp} namespace: `, reason)
        }).on('error', error => {
            error
        })

        resolve(sockets[namespaceKey][socketIndex])
    })
}
const sio = ioInit()

export {
    sio,
    sockets,
    ioInit
}
